import { Disclaimer } from './Disclaimer/disclaimer';
import { Main } from './Main/main';
import { PageLoading } from './PageLoading/page-loading';
import { PageRoot } from './PageRoot/page-root';
import { PageStreamingIndicator } from './PageStreamingIndicator/page-streaming-indicator';
import { PageTrigger } from './PageTrigger/page-trigger';
import { Prompt } from './Prompt/prompt';
import { Root } from './Root/root';
import { Stream } from './Stream/stream';
import { Thread } from './Thread/thread';

export const components = {
  Disclaimer,
  Main,
  PageLoading,
  PageRoot,
  PageStreamingIndicator,
  PageTrigger,
  Prompt,
  Root,
  Stream,
  Thread,
};
